module.exports = __webpack_public_path__ + "img/first_city_monument_bank.0564d191.svg";